import mitt from 'mitt';

const emitter = mitt();

export const loadingEventBus = emitter;

export const showLoading = () => {
  emitter.emit('loading:show');
};

export const hideLoading = () => {
  emitter.emit('loading:hide');
};

export const withLoading = async (apiCall) => {
  showLoading();
  try {
    const result = await apiCall();
    return result;
  } finally {
    hideLoading();
  }
};